import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddNewVendorComponent } from 'src/app/Product/add-new-vendor/add-new-vendor.component';
import { ConfirmNewVendorComponent } from 'src/app/Product/confirm-add-new-vendor/confirm-new-vendor/confirm-new-vendor.component';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { VendorService } from 'src/app/_services/vendor.service';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-confirm-add-new-vendor',
  templateUrl: './confirm-add-new-vendor.component.html',
  styleUrls: ['./confirm-add-new-vendor.component.css']
})
export class ConfirmAddNewVendorComponent implements OnInit {
  test: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddNewVendorComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private loginService: LoginService,
    private authService: AuthService,
    private alertService: AlertService,
    private vendorService: VendorService
  ) { }

  ngOnInit(): void {
    // this.allVendorDetails()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  allVendorDetails() {
    this.vendorService.Allvendors('', '').subscribe((response) => {
      this.data.companyName = response[response.length - 1]['vendorId'],
        this.data.companyContact = response[response.length - 1]['phone']
    })
  }

  onSubmit() {
    const token = this.authService.getToken();
    this.vendorService.registerVendor(this.data, token)
      .subscribe((response) => {
        console.log(response);
        if (response.errors) {
          this.alertService.error('Error! ' + response.errors + 'Please try with another e-mail id.', this.options);
        }
        else {
          this.allVendorDetails();
          const dialogRef = this.dialog.open(ConfirmNewVendorComponent, {
            width: '500px',
            disableClose: true
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
        this.test = (response['data'].vendorRegistrationId);
        this.authService.setId(this.test);
        this.alertService.success('Success!! Vendor Details Saved SuccessFully.', this.options);
      }, (error) => {
        console.log(error);
      })

  }
}


